import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { ChartOutput } from '../domain/dtos/chart-output'
import { GetActiveSubscriptionsInput } from '../domain/dtos/get-active-subscriptions-input'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'
import { GetOfferIds } from './get-offer-ids'

export class GetActiveSubscriptions {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(input: GetActiveSubscriptionsInput, signal?: AbortSignal): Promise<ChartOutput> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.BFF_WEB_URL}/receiver/summary/subscriptions/activated`,
      body: this.makeBody(input),
      signal,
    })

    if (response.statusCode === HttpStatusCode.OK) {
      return response.data
    }

    throw new GeneralError()
  }

  private makeBody(input: GetActiveSubscriptionsInput) {
    const offerIds = new GetOfferIds().execute({ offerIds: input.offerIds, offers: input.offers })

    const body = {
      period: input.period,
      startDate: input.startDate,
      endDate: input.endDate,
      offerIds,
    }

    return body
  }
}
